import { Model } from "./models";

export const TOKEN_LIMIT = 8192;
export const MAX_CONTEXT_INFO = 6000;

export const DEFAULT_MODEL: Model = "gpt-4";
